import { Button } from 'primitives/button'
import { Stack } from 'primitives/containers'
import React from 'react'

export const ScrollerCollectionControls = () => {
  const scrollUp = () => {
    window.frameElement.parentElement.previousSibling.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
    })
  }

  const scrollDown = () => {
    window.frameElement.parentElement.nextSibling.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
    })
  }

  return (
    <Stack
      gap={2}
      css={{
        position: 'absolute',
        top: '50%',
        right: 10,
        transform: 'translateY(-50%)',
        button: {
          padding: '$3',
          background: 'rgba(1, 1, 1, 0.2)',
          color: 'white',
          border: 'none',
          borderRadius: '$3',
        },
      }}
    >
      <Button onClick={scrollUp}>
        <i className="fas fa-caret-up" />
      </Button>
      <Button onClick={scrollDown}>
        <i className="fas fa-caret-down" />
      </Button>
    </Stack>
  )
}
